import React, { useEffect, useState } from 'react'
import URL from '../../services/API_URL'
import { useLocation, useNavigate } from 'react-router-dom'
import StructureQuestionPage from './StructureQuestionPage';
import Timer from '../Timer';
import Swal from 'sweetalert2'

const IELTStestPageStructure = ({ nextPage }) => {
  const [soalStructure, setSoalStructure] = useState(null)
  const location = useLocation();
  const navigate = useNavigate();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [startTime, setStartTime] = useState(false)
  const [popup, setPopup] = useState(true)
  const [answerState, setAnswerState] = useState([])

  useEffect(() => {
    if (location.state == null) {
      navigate('/start-toefl-test')
    } else {
      if (popup) {
        Swal.fire({
          title: "Are you ready for Structure Section?",
          confirmButtonText: "Start",
          allowOutsideClick: false,
          icon: "question",
        }).then((result) => {
          if (result.isConfirmed) {
            setPopup(false)
            getSoal()
            setStartTime(true)
          }
        });
      }
    }
  }, [])

  const submit = () => {
    setBtnDisabled(true)
    for (let i = 0; i < answerState.length; i++) {
        if (answerState[i].correct_answer === answerState[i].user_answer) {
            answerState[i].is_correct = true
            answerState.push()
        } else {
            answerState[i].is_correct = false
            answerState.push()
        }
    }
    let jawaban = answerState.filter((x) => x.is_correct == true)
    let data = {
        id_user:answerState[0].id_user,
        total_correct: jawaban.length,
        type: 'structure',
        answer: answerState
    }
    URL.API_URL.post('store-answer', data)
        .then((res) => {
            Swal.fire({
                icon: "success",
                title: "Your Structure Answers Saved",
                showConfirmButton: false,
                timer: 2500,
                willClose: () => {
                    setBtnDisabled(false)
                    nextPage(3)
                }
            });
        })
        .catch((err) => {
            setBtnDisabled(false)
        })
}

  const getSoal = () => {
    let formData = new FormData()
    formData.append('id', 2)
    URL.API_URL.post('load-soal', formData)
      .then((res) => {
        setSoalStructure(res.data.data)
        let data = res.data.data.part_soal
        let answer = []
        for (let i = 0; i < data.length; i++) {
          let soal = data[i].soal
          for (let j = 0; j < soal.length; j++) {
            answer.push({ id_user: location.state?.id, id_soal: soal[j].id, correct_answer: soal[j].correct_answer, user_answer: '', is_correct: false })
          }
        }
        setAnswerState(answer)
      })
      .catch((err) => console.log(err))
  }

  return (
    <>
      <header className="bg-blue">
        <h2 className='text-white'>Structure Section</h2>
        {soalStructure == null ? '' : <Timer timer={1500} category={'structure'} startTime={startTime} setInputDisabled={setInputDisabled} />}
        <div className="nav-control">
          <button onClick={submit} className='btn btn-success'>Submit</button>
        </div>
      </header>
      <div className="ielts-content">
        {soalStructure == null ? '' : <StructureQuestionPage answerState={answerState} soal={soalStructure} inputDisabled={inputDisabled} />}
      </div>
    </>
  )
}

export default IELTStestPageStructure